import Content from './Components/Content/Content';

function App() {
  return(
    <Content/>  
  )
}

export default App;
